<template>
<div class="be-left-sidebar">
  <div class="left-sidebar-wrapper">
    <a class="left-sidebar-toggle" href="#">Navigation</a>
    <div class="left-sidebar-spacer">
      <div class="left-sidebar-scroll">
        <div class="left-sidebar-content">

          <ul class="sidebar-elements">
            <li class="divider">Menu</li>
            <router-link :to="{name: 'subject-shelf'}" tag="li">
              <a><i class="icon fas fa-home"></i><span>Subject Shelf</span></a>
            </router-link>

            <router-link :to="{name: 'importer'}" tag="li" v-if="showImport">
              <a><i class="icon fas fa-cloud-upload-alt"></i><span>Import Lecture Notes</span></a>
            </router-link>

            <router-link :to="{name: 'exporter'}" tag="li" v-if="showImport">
              <a><i class="icon fas fa-file-export"></i><span>Export Lecture Notes</span></a>
            </router-link>

            <router-link :to="{name: 'receive-chapter'}" tag="li" v-if="receivedShares.length > 0">
              <a><i class="icon fas fa-share-square"></i><span>Shared Lecture Notes</span></a>
            </router-link>

            <!--             <li class="divider">Chapter Studier</li>
  <router-link :to="{name: 'chapter-studier', params: {chapterId: 1}}" exact tag="li">
    <a><i class="icon mdi mdi-play-circle-outline"></i><span>Study Chapter 1</span></a>
  </router-link> -->
            <!-- <li class="divider">Micro Notes</li> -->
            <!--             <router-link :to="{name: 'micro-notes', params: {chapterId: 1}}" exact tag="li">
    <a><i class="icon mdi mdi-collection-text"></i><span>Micro Notes</span></a>
  </router-link> -->
            <!--             <router-link :to="{name: 'micro-note-editor', params: {chapterId: 1}}" tag="li">
    <a><i class="icon mdi mdi-format-color-text"></i><span>Edit Micro Notes</span></a>
  </router-link> -->
            <!--             <router-link :to="{name: 'lecture-notes'}" exact tag="li">
    <a><i class="icon mdi mdi-folder-outline"></i><span>Lecture Notes</span></a>
  </router-link> -->
            <!--             <router-link :to="{name: 'lecture-note-editor', params: {id: 1}}" tag="li">
    <a><i class="icon mdi mdi-edit"></i><span>Lecture Note Editor</span></a>
  </router-link> -->



            <li class="divider" v-if="showAdmin">Admin</li>

            <router-link :to="{name: 'ad-manager'}" tag="li" v-if="showAdmin">
              <a><i class="icon mdi mdi-view-dashboard"></i><span>Manage Ads</span></a>
            </router-link>
            <router-link :to="{name: 'blog-manager'}" tag="li" v-if="showAdmin || showBlogger">
              <a><i class="icon fas fa-font"></i><span>Manage Blog</span></a>
            </router-link>
            <router-link :to="{name: 'user-manager'}" tag="li" v-if="showAdmin">
              <a><i class="icon fas fa-users"></i><span>Manage Users</span></a>
            </router-link>
            <router-link :to="{name: 'user-activity-report'}" tag="li" v-if="showAdmin">
              <a><i class="icon fas fa-user-clock"></i><span>User Activity Report</span></a>
            </router-link>
          </ul>

        </div>
      </div>
    </div>

    <div v-if="studyProgressPercent || totalNotesCount" class="progress-widget">
      <div class="progress-data"><span class="progress-value">{{completedNotesCount}}/{{totalNotesCount}}</span><span class="name">Study Progress</span></div>
      <div class="progress">
        <div :style="'width: ' + studyProgressPercent + '%'" class="progress-bar progress-bar-primary" :class="{'progress-bar-success': studyProgressPercent === 100}"></div>
      </div>
    </div>


  </div><!-- /.left-sidebar-wrapper -->
</div><!-- /.be-left-sidebar -->
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
  import _ from 'underscore'


  export default {
    components: {
    },

  mounted() {
    // console.log('mounted')
    window.leftSidebarInit() //#todo
  },

  computed: {
    ...mapState([
      'currentUser',
    ]),
    ...mapGetters({
      receivedShares: 'receivedShares',
    }),
    studyProgressPercent() {
      if( !this.totalNotesCount) return null;
      return Math.round(this.completedNotesCount / this.totalNotesCount * 100);
    },
    completedNotesCount() {
      if( !this.totalNotesCount) return 0;
      const unstudiedMicroNotes = this.$store.getters.unstudiedMicroNotes;
      return _.isArray(unstudiedMicroNotes) ? (this.totalNotesCount - unstudiedMicroNotes.length) : 0;
    },
    totalNotesCount() {
      const allMicroNotes = this.$store.getters.allMicroNotes;
      return _.isArray(allMicroNotes) ? allMicroNotes.length : 0;
    },
    showAdmin() {
      return this.currentUser.role === 'admin';
    },
    showImport() {
      return this.currentUser.role !== 'student';
    },
    showBlogger() {
      return this.currentUser.role === 'blogger';
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .ad {margin:10px;}

</style>



// WEBPACK FOOTER //
// Sidebar.vue?0e33856e